import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, X } from "@phosphor-icons/react";
import PageHeader from "@/components/PageHeader";

const STAGES = ["idea", "guest_outreach", "scheduled", "recorded", "editing", "published"];

export default function Episodes() {
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [f, setF] = useState({ title: "", theme: "", stage: "idea", publish_date: "" });

  const load = async () => setItems((await api.get("/episodes")).data);
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    await api.post("/episodes", { ...f, publish_date: f.publish_date || null });
    toast.success("Episode added");
    setShowForm(false);
    setF({ title: "", theme: "", stage: "idea", publish_date: "" });
    load();
  };

  const move = async (id, stage) => {
    await api.patch(`/episodes/${id}`, { stage });
    load();
  };

  const grouped = STAGES.map((s) => ({ stage: s, items: items.filter((e) => e.stage === s) }));

  return (
    <div className="p-8 max-w-[1600px] mx-auto">
      <PageHeader
        overline="Production Pipeline"
        title="Episodes"
        subtitle="From idea → published. Every ship, tracked."
        actions={<button data-testid="new-episode-btn" onClick={() => setShowForm(true)} className="btn-primary text-sm flex items-center gap-1"><Plus size={14} /> New episode</button>}
      />

      {showForm && (
        <div className="oz-card p-5 mb-6">
          <form onSubmit={create} className="grid md:grid-cols-2 gap-3">
            <input required placeholder="Title" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} className="col-span-2 bg-[color:var(--oz-page)] border border-[color:var(--oz-border)] px-3 py-2 text-sm rounded-sm" />
            <input placeholder="Theme" value={f.theme} onChange={(e) => setF({ ...f, theme: e.target.value })} className="bg-[color:var(--oz-page)] border border-[color:var(--oz-border)] px-3 py-2 text-sm rounded-sm" />
            <select value={f.stage} onChange={(e) => setF({ ...f, stage: e.target.value })} className="bg-[color:var(--oz-page)] border border-[color:var(--oz-border)] px-3 py-2 text-sm rounded-sm">
              {STAGES.map((s) => <option key={s}>{s}</option>)}
            </select>
            <input type="date" value={f.publish_date} onChange={(e) => setF({ ...f, publish_date: e.target.value })} className="col-span-2 bg-[color:var(--oz-page)] border border-[color:var(--oz-border)] px-3 py-2 text-sm rounded-sm font-mono" />
            <div className="col-span-2 flex gap-2">
              <button className="btn-primary text-sm">Save</button>
              <button type="button" onClick={() => setShowForm(false)} className="btn-ghost text-sm">Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {grouped.map((col) => (
          <div key={col.stage} className="kanban-col p-3" data-testid={`col-${col.stage}`}>
            <div className="flex items-center justify-between mb-3">
              <div className="overline text-[10px]">{col.stage.replace("_", " ")}</div>
              <div className="text-xs font-mono text-[color:var(--oz-text-muted)]">{col.items.length}</div>
            </div>
            <div className="space-y-2">
              {col.items.map((e) => (
                <div key={e.id} className="p-3 rounded-sm border border-[color:var(--oz-border)] bg-[color:var(--oz-page)] hover:border-[color:var(--oz-emerald)] transition-colors" data-testid={`ep-${e.id}`}>
                  <div className="text-sm text-[color:var(--oz-text)] mb-1">{e.title}</div>
                  {e.theme && <div className="text-[11px] text-[color:var(--oz-text-muted)] mb-2">{e.theme}</div>}
                  {e.publish_date && <div className="text-[10px] font-mono text-[color:var(--oz-text-muted)] mb-2">→ {new Date(e.publish_date).toLocaleDateString()}</div>}
                  <select value={e.stage} onChange={(ev) => move(e.id, ev.target.value)} className="w-full bg-transparent border border-[color:var(--oz-border)] px-2 py-1 text-[10px] rounded-sm font-mono">
                    {STAGES.map((s) => <option key={s}>{s}</option>)}
                  </select>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
